import BaseService from "./Base"
import {ApiListResponse, ApiResponse} from "types/api"
import type {
    EventTypeQuestionnaireGetPayload,
    EventTypeQuestionnaireListResponse,
    EventTypeQuestionnaireUpdatePayload
} from "types/event-type"
import {AxiosResponse} from "axios"

export class EventTypeService extends BaseService {
    getAll = async (body: {linkedEntities?: string[]} & Record<string, any> = {}) => {
        const {linkedEntities = [], ...rest} = body
        const {data: response}: AxiosResponse<ApiListResponse<any[]>> = await this.post("/v1/event-type/list", {
            ...rest,
            linkedEntities: ["lastUpdatedBy", "department", "outcomeGroups", ...linkedEntities]
        })
        if (!response.success) {
            throw response
        }

        return {
            data: response.data,
            total: response.total
        }
    }

    getEventTypes = async (params: any) => {
        const {data: response}: AxiosResponse<ApiListResponse<any[]>> = await this.post("/v1/event-type/list", params)
        if (!response.success) {
            throw response
        }

        return {
            data: response.data,
            total: response.total
        }
    }

    getOne = async (eventTypeId: number): Promise<any | null> => {
        const {data: response}: AxiosResponse<ApiResponse<any[]>> = await this.post("/v1/event-type/list", {
            filter: {
                id: [eventTypeId]
            },
            linkedEntities: ["lastUpdatedBy", "department", "outcomeGroups", "profileLeadSource", "profileStatus"]
        })

        if (!response.success) {
            throw response
        }

        return response.data[0] ?? null
    }

    create = async (payload: any): Promise<{eventTypeId?: number} | undefined> => {
        try {
            const {data: response}: AxiosResponse<ApiResponse<{eventTypeId?: number}>> = await this.post(
                "/v1/event-type/create",
                payload
            )

            if (!response.success) {
                throw response
            }

            return response.data
        } catch (e: any) {
            throw e
        }
    }
    duplicate = async (eventTypeIds: number[]) => {
        const {data: response}: AxiosResponse<ApiResponse> = await this.post("/v1/event-type/duplicate", {
            id: eventTypeIds
        })

        if (!response.success) {
            throw response
        }
    }

    update = async (payload: any) => {
        try {
            const {data: response}: AxiosResponse<ApiResponse> = await this.post("/v1/event-type/edit", payload)

            if (!response.success) {
                throw response
            }
        } catch (e: any) {
            throw e
        }
    }

    deleteBulk = async (eventTypeIds: number[]) => {
        const {data: response}: AxiosResponse<ApiResponse> = await this.post("/v1/event-type/delete", {
            id: eventTypeIds
        })

        if (!response.success) {
            throw response
        }
    }

    getQuestionnaire = async (
        payload: EventTypeQuestionnaireGetPayload
    ): Promise<EventTypeQuestionnaireListResponse> => {
        const {data: response}: AxiosResponse<ApiResponse<EventTypeQuestionnaireListResponse>> = await this.post(
            "/v1/event-type/questionnaire/list",
            payload
        )

        if (!response.success) {
            throw response
        }

        return response.data
    }

    getPublicQuestionnaire = async (payload: {eventTypeId: number; slug: string}) => {
        const {data: response}: AxiosResponse<ApiResponse<EventTypeQuestionnaireListResponse>> = await this.post(
            "/v1/event-type/questionnaire/public/list",
            payload
        )

        if (!response.success) {
            throw response
        }

        return response.data
    }

    updateQuestionnaire = async (payload: EventTypeQuestionnaireUpdatePayload) => {
        const {data: response}: AxiosResponse<ApiResponse> = await this.post(
            "/v1/event-type/questionnaire/update",
            payload
        )

        if (!response.success) {
            throw response
        }
    }
}
